import styled from '@emotion/styled'
import TabPanel from '@mui/lab/TabPanel'
import {
    Box,
    Card,
    DialogContent,
    FormControl,
    Typography,
} from '@mui/material'
import theme from 'candidate/theme'
import { getPxAsRem } from 'shared/utils'

export const EmailLink = styled.a`
    font-family: 'Roboto';
    font-size: ${getPxAsRem(14)};
    color: ${({ theme }) => theme.palette.other.link};
    text-decoration: none;
    max-width: 10rem;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    display: block;
`

export const baseStyle = {
    padding: getPxAsRem(64),
    margin: getPxAsRem(28),
    borderWidth: 2,
    borderRadius: 2,
    borderColor: theme.palette.grey[300],
    borderStyle: 'dashed',
    backgroundColor: theme.palette.background.default,
    outline: 'none',
    transition: 'border .24s ease-in-out',
}

export const TabsContainer = styled(Box)`
    background-color: ${({ theme }) => theme.palette.greyscale.white};
    width: 100%;

    .Mui-selected {
        color: ${({ theme }) => theme.palette.other.link};
    }
    .MuiTabs-indicator {
        background-color: ${({ theme }) => theme.palette.other.link};
    }
`

export const StyledTabPanel = styled(TabPanel)`
    background-color: ${({ theme }) => theme.palette.other.background};
`

export const EditHeader = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
`

export const StyledDialogContent = styled(DialogContent)`
    padding: ${getPxAsRem(32)};
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: ${getPxAsRem(24)};
    min-width: ${getPxAsRem(300)};
    min-height: ${getPxAsRem(300)};
`
export const StyledCard = styled(Card)(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    padding: getPxAsRem(16),
    maxHeight: getPxAsRem(350),
    overflow: 'auto',
}))

export const StyledTypography = styled(Typography)(({ theme }) => ({
    display: '-webkit-box',
    WebkitBoxOrient: 'vertical',
    overflow: 'hidden',
    WebkitLineClamp: 3,
    textOverflow: 'ellipsis',
}))

export const StyledBox = styled(Box)(({ theme }) => ({
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: getPxAsRem(8),
}))

export const DialogButtonContainer = styled(FormControl)`
    display: flex;
    gap: ${getPxAsRem(8)};
    flex-direction: row;
`

export const Subtitle = styled(Typography)`
    color: ${({ theme }) => theme.palette.other.secondary_light};
    font-weight: 600;
`
